import React from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { PlayCircle } from "lucide-react";

interface VideoModalProps {
  videoUrl?: string;
  vimeoId?: string;
  title?: string;
  trigger?: React.ReactNode;
  className?: string;
}

export const VideoModal: React.FC<VideoModalProps> = ({
  videoUrl,
  vimeoId,
  title = "Video",
  trigger,
  className = "",
}) => {
  const defaultTrigger = (
    <Button variant="outline" className="gap-2">
      <PlayCircle className="h-4 w-4" />
      Se film
    </Button>
  );

  return (
    <Dialog>
      <DialogTrigger asChild>
        {trigger || defaultTrigger}
      </DialogTrigger>
      <DialogContent className={`max-w-4xl w-full p-0 ${className}`}>
        <div className="w-full" style={{ aspectRatio: '16/9', maxWidth: '1280px', maxHeight: '720px' }}>
          {vimeoId ? (
            <iframe
              src={`https://player.vimeo.com/video/${vimeoId}?autoplay=1&title=0&byline=0&portrait=0`}
              width="100%"
              height="100%"
              frameBorder="0"
              allow="autoplay; fullscreen; picture-in-picture"
              allowFullScreen
              className="w-full h-full"
              loading="lazy"
            />
          ) : videoUrl ? (
            <video
              controls
              autoPlay
              className="w-full h-full object-cover"
              preload="metadata"
            >
              <source src={videoUrl} type="video/mp4" />
              <source src={videoUrl} type="video/webm" />
              Your browser does not support the video tag.
            </video>
          ) : (
            <div className="w-full h-full flex items-center justify-center text-muted-foreground">
              <div className="text-center">
                <PlayCircle className="h-16 w-16 mx-auto mb-4 opacity-50" />
                <p>No video available</p>
              </div>
            </div>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};